// extracted by mini-css-extract-plugin
export default {"plateLabel":"plateLabel-qL5FT"};